var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpRecap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-053-1,.cls-128-053-3{fill:#fff;}.cls-128-053-2{fill:none;}.cls-128-053-2,.cls-128-053-3{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-053-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 107.22,
    y1: 40.95,
    x2: 107.22,
    y2: 96.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 17.52,
    y1: 40.95,
    x2: 17.52,
    y2: 96.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 32.54,
    y1: 52.8,
    x2: 32.54,
    y2: 101.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 62.37,
    y1: 55.62,
    x2: 62.37,
    y2: 104.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 92.2,
    y1: 52.8,
    x2: 92.2,
    y2: 101.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-053-2",
    cx: 62.37,
    cy: 40.95,
    rx: 44.85,
    ry: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-053-2",
    d: "M107.22,47.1c0,6.16-20.08,11.14-44.85,11.14s-44.85-5-44.85-11.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-053-2",
    d: "M107.22,90c0,6.16-20.08,11.14-44.85,11.14S17.52,96.19,17.52,90"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-053-2",
    d: "M107.22,96c0,6.16-20.08,11.15-44.85,11.15s-44.85-5-44.85-11.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 18.3,
    y1: 25.86,
    x2: 52.29,
    y2: 42.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-053-2",
    x1: 105.88,
    y1: 20.08,
    x2: 72.31,
    y2: 36.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-053-3",
    cx: 54.97,
    cy: 44.19,
    r: 3.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-053-3",
    cx: 69.44,
    cy: 38.21,
    r: 3.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-053-2",
    points: "107.22 63.45 110.04 63.45 110.04 73.88 107.22 73.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-053-2",
    points: "17.52 73.88 14.7 73.88 14.7 63.45 17.52 63.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-053-3",
    x: 29.72,
    y: 70.44,
    width: 5.64,
    height: 10.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-053-3",
    x: 89.38,
    y: 70.44,
    width: 5.64,
    height: 10.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-053-3",
    x: 59.55,
    y: 74.66,
    width: 5.64,
    height: 10.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpRecap);
export default __webpack_public_path__ + "static/media/OP_recap.e8900716e31c02c681fe5488794325c7.svg";
export { ForwardRef as ReactComponent };